import { categories, categoryImages } from "@/mocks/articles";

export default function CategorySection() {
  return (
    <section className="py-20 md:py-24 bg-white" data-product-shop>
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-3">
              <span className="h-px w-8 bg-amber-500"></span>
              <span className="text-amber-500 text-xs font-bold uppercase tracking-[0.2em]">Shop by Category</span>
            </div>
            <h2 className="text-3xl md:text-5xl font-black text-gray-900 leading-tight">
              Find Your<br />
              <span className="text-amber-500">Perfect Style</span>
            </h2>
          </div>
          <p className="text-gray-500 text-sm leading-relaxed max-w-xs md:text-right">
            Browse our curated collection of top-quality fashion across all categories. Every HipoBuy 2026 purchase is quality guaranteed.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat, idx) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="group relative overflow-hidden rounded-2xl cursor-pointer block"
            >
              {/* Image */}
              <div className="aspect-[3/4] overflow-hidden rounded-2xl bg-stone-100">
                <img
                  src={categoryImages[idx]}
                  alt={`${cat.name} - HipoBuy 2026`}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                />
              </div>

              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent rounded-2xl"></div>

              {/* Hover overlay */}
              <div className="absolute inset-0 bg-amber-500/0 group-hover:bg-amber-500/15 transition-all duration-300 rounded-2xl"></div>

              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <div className="w-8 h-8 flex items-center justify-center bg-white/15 backdrop-blur-sm rounded-full mb-2 group-hover:bg-amber-500 transition-colors duration-300">
                  <i className={`${cat.icon} text-white text-sm`}></i>
                </div>
                <span className="text-white font-bold text-sm leading-tight block">{cat.name}</span>
                <div className="flex items-center gap-1 mt-1 text-white/50 text-xs group-hover:text-amber-300 transition-colors">
                  Shop Now
                  <div className="w-3 h-3 flex items-center justify-center translate-x-0 group-hover:translate-x-1 transition-transform">
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://repsw2c.com/"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-4 bg-gray-900 hover:bg-amber-500 text-white font-bold rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap text-sm"
          >
            Browse All Categories
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </a>
          <span className="text-gray-400 text-sm">10,000+ products available</span>
        </div>
      </div>
    </section>
  );
}
